export default __webpack_public_path__ + "static/media/primary.cf07f5099f3279250973ce8c418bb1f4.svg";